module.exports = __webpack_public_path__ + "static/media/technovation.e9f893a6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/technovation.png
 ** module id = 157
 ** module chunks = 0
 **/